<script>
import Maps from '@jntestapparatuur/appointments/js/maps';
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import {useForm} from "@inertiajs/vue3";
import moment from "@wielink-application/shared/js/mixins/moment";

let googleApi = {};
let mapApi = {};
let mapMarkers = [];

export default {
  mixins: [FormElements, moment],

  props: {
    googleClientSideKey: {
      type: String
    },
    appointment: {
      type: Object
    }
  },

  emits: ['add:appointment', 'set:appointment'],

  data() {
    return {
      mapIsInitialised: false,
      user: {},
      customer: {},
      customers: [],
      upcoming: [],
      form: useForm({
        radius: 20,
        months: 2,
        sort: 'distance||asc',
        start_date: '',
        end_date: '',
        customer_id: '',
      })
    }
  },

  methods: {
    async initialiseGoogleMaps(event) {
      let map = this.$refs.map;
      let $map = $(this.$refs.map);
      $map.removeClass('d-none');
      let googleData = await (new Maps({scope: map})).init();

      googleApi = googleData.google;
      mapApi = googleData.maps;

      this.mapIsInitialised = true;

      $(document).off('.appointments').on('click.appointments', '[data-add-appointment]', (event) => {
        event.preventDefault();
        let customer = $(event.currentTarget).data('customer');
        this.addAppointment(customer);
      });

      this.changeMarkers();
    },

    async getRecommendedCustomers(changedColumn) {
      if (changedColumn === 'customer_id') {
        await this.getCustomer();
      }

      this.form.customer_id = this.appointment.customer_id;
      this.form.start_date = this.appointment.start_date;
      this.form.end_date = this.appointment.end_date;

      if (!this.customer.lat || !this.customer.lon || !this.form.start_date || !this.form.end_date) {
        this.customers = [];
        return;
      }

      await $.ajax({
        url: route('api.v1.customers.recommended'),
        data: this.form.data(),
        success: (response) => {
          if(Object.keys(response.data).length < 1) {
            this.customers = [];
            return;
          }
          this.customers = response.data;
        }
      });

      this.changeMarkers();
    },

    getUpcomingCustomers() {
      $.ajax({
        url: route('api.v1.appointments.upcoming'),
        data: {
          overdue: 0,
          months: 2,
          limit: 0
        },
        success: (response) => {
          this.upcoming = response.data;
        }
      })
    },

    getCustomer() {
      return new Promise((resolve) => {
        if (!this.appointment.customer_id) {
          this.customer = {};
          resolve(true);
          return;
        }

        $.ajax({
          url: route('api.v1.customers.show', {customer: this.appointment.customer_id}),
          success: (response) => {
            this.customer = response.data;
          }
        }).always(() => {
          resolve(true);
        });
      })
    },

    getEmployee() {
      return new Promise((resolve) => {
        if (!this.appointment.user_id) {
          resolve(true);
          return;
        }

        $.ajax({
          url: route('api.v1.users.show', {user: this.appointment.user_id}),
          success: (response) => {
            this.user = response.data;
          }
        }).always(() => {
          resolve(true);
        });
      })
    },

    addAppointment(customer) {
      this.$emit('add:appointment', {
        start_date: this.appointment.start_date,
        end_date: this.appointment.end_date,
        customer: customer,
        user: this.user
      });
    },

    setAppointment(customer) {
      this.$emit('set:appointment', {
        customer: customer,
        user: this.user
      });
    },

    rounded(km) {
      return Math.round(km);
    },

    changeMarkers() {
      if (!this.mapIsInitialised) {
        return;
      }

      for (let i in mapMarkers) {
        mapMarkers[i].setMap(null);
      }
      let bounds = new googleApi.maps.LatLngBounds();
      const svgmarker = {
        path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
        fillColor: "blue",
        fillOpacity: 0.6,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
        anchor: new google.maps.Point(0, 20),
      }

      mapMarkers = [];

      let customer = this.customer;
      let marker = new googleApi.maps.Marker({
        position: {
          lng: parseFloat(customer.lon),
          lat: parseFloat(customer.lat),
        },
        style: {
          background: "#FBBC04",
        },
        infoWindowHtml: this.getInfoWindow(customer),
        map: mapApi,
        title: customer.name,
        icon: svgmarker
      })

      mapMarkers.push(marker);

      for (let index in this.customers) {
        let customer = this.customers[index];
        let marker = new googleApi.maps.Marker({
          position: {
            lng: parseFloat(customer.lon),
            lat: parseFloat(customer.lat),
          },
          style: {
            background: "#FBBC04",
          },
          infoWindowHtml: this.getInfoWindow(customer),
          map: mapApi,
          title: customer.name,
        })

        mapMarkers.push(marker);
        bounds.extend(marker.position);
      }

      if (mapMarkers.length === 1) {
        google.maps.event.addListenerOnce(mapApi, 'bounds_changed', function () {
          mapApi.setZoom(10);
        });
      }

      if (mapMarkers.length < 1) {
        return;
      }

      mapApi.fitBounds(bounds);

      this.infoWindow();
    },

    getInfoWindow(customer) {
      return `
        <div style="font-size: 16px">
            <div>
                Bedrijf: ${customer.name ?? '-'} <br>
                Adres: ${customer.address}, ${customer.zipcode} ${customer.city} <br>
                Telefoon: ${customer.phone ?? '-'} <br>
                Mobiel: ${customer.mobile ?? '-'} <br>
                E-mail: ${customer.email ?? '-'} <br>
            </div>

            <a data-add-appointment data-customer='${JSON.stringify(customer)}' style="margin-top: 16px; display: block;" href="#">Afspraak toevoegen</a>
        </div>
      `
    },

    async infoWindow() {
      setTimeout(() => {
        // one instance of infowindow so we don't have multiple info windows open
        let infowindow = new googleApi.maps.InfoWindow();

        mapMarkers.forEach((element, index) => {
          googleApi.maps.event.addListener(element, 'click', () => {
            infowindow.setContent(element.infoWindowHtml);
            infowindow.open(mapApi, element);
          });
        })
      }, 1000)
    },
  },

  mounted() {
    this.getUpcomingCustomers();
    this.$watch('appointment.user_id', this.getEmployee.bind(this))
    this.$watch('form.sort', this.getRecommendedCustomers.bind(this, 'sort'))
    this.$watch('form.radius', this.getRecommendedCustomers.bind(this, 'radius'))
    this.$watch('form.months', this.getRecommendedCustomers.bind(this, 'months'))
    this.$watch('appointment.customer_id', this.getRecommendedCustomers.bind(this, 'customer_id'))
    this.$watch('appointment.start_date', this.getRecommendedCustomers.bind(this, 'start_date'))
    this.$watch('appointment.end_date', this.getRecommendedCustomers.bind(this, 'end_date'))
  },
}
</script>

<template>
  <form action="">
    <div class="p-3 border mb-4">
      <h3 class="card-title mb-4">Aanbevolen extra afspraken:</h3>

      <Select
          :form="form"
          v-model="form.radius"
          name="radius"
          label="Radius"
          :options="[
              {value: 5, label: '5km'},
              {value: 10, label: '10km'},
              {value: 15, label: '15km'},
              {value: 20, label: '20km'},
              {value: 40, label: '40km'},
              {value: 50, label: '50km'},
              {value: 60, label: '60km'},
              {value: 70, label: '70km'},
              {value: 80, label: '80km'},
              {value: 90, label: '90km'},
              {value: 100, label: '100km'},
          ]"
          :required="true"
      />

      <Input
          :form="form"
          v-model="form.months"
          name="months"
          label="Maanden tot Verloopdatum"
          type="number"
          :required="true"
      />

      <Select
          :form="form"
          v-model="form.sort"
          name="sort"
          label="Sorteren op:"
          :options="[
              {value: 'distance||asc', label: 'Afstand oplopend'},
              {value: 'distance||desc', label: 'Afstand aflopend'},
              {value: 'next_inspection_date||asc', label: 'Verloopdatum oplopend'},
              {value: 'next_inspection_date||desc', label: 'Verloopdatum aflopend'},
          ]"
          :required="true"
      />

      <div class="table-responsive">
        <table v-if="appointment.customer_id" class="table table-sm table-striped m-0">
          <thead>
            <tr>
              <th>Klant</th>
              <th>Verloopdatum</th>
              <th>Afstand</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="customer in customers" valign="middle" :key="customer.id">
              <td style="white-space: nowrap">{{ customer.company ?? customer.name }}</td>
              <td style="white-space: nowrap">{{ dateFormat(customer.valid_until) }}</td>
              <td style="white-space: nowrap">{{ rounded(customer.distance) }}km</td>
              <td style="white-space: nowrap">
                <a class="btn btn-link p-0" href="#" @click.prevent="addAppointment(customer)">Afspraak toevoegen</a>
              </td>
            </tr>

            <tr v-if="customers.length < 1">
              <td colspan="5">Er zijn geen aanbevolen afspraken</td>
            </tr>
          </tbody>
        </table>

        <table v-if="!appointment.customer_id" class="table table-sm table-striped m-0">
          <thead>
            <tr>
              <th>Klant</th>
              <th>Verloopdatum</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="customer in upcoming" valign="middle" :key="customer.id">
              <td style="white-space: nowrap">{{ customer.company ?? customer.name }}</td>
              <td style="white-space: nowrap">{{ dateFormat(customer.valid_until) }}</td>
              <td style="white-space: nowrap">
                <a class="btn btn-link p-0" href="#" @click.prevent="setAppointment(customer)">Afspraak toevoegen</a>
              </td>
            </tr>

            <tr v-if="upcoming.length < 1">
              <td colspan="5">Er zijn geen aanbevolen afspraken</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <button v-if="googleClientSideKey && customers.length > 0 && !mapIsInitialised" @click.prevent="this.initialiseGoogleMaps" class="btn btn-primary">Aanbevelingen tonen op kaart</button>
    <div v-if="googleClientSideKey" class="d-none" ref="map" :data-key="googleClientSideKey" style="aspect-ratio:16/9"></div>
  </form>
</template>